
export default {
    props: {
        id: {
            default: '',
            type: String,
        },
        header: {
            default: 'true',
            type: String,
        },
        classes: {
            default: 'py-8 px-4 md:px-4 bg-blue-50',
            type: String,
        },
        region: {
            default: 'uk',
            type: String,
        }
    },
    data(){
        return{
             isVisible:false
        }
    },
    methods:{
        visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
      console.log(isVisible, entry)
    }
  
    }
}
